"use client";

import React, { useEffect, useState } from "react";
import { ChevronRight, House as Home } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
interface BreadcrumbConfig {
  labelEn: string;
  labelZh: string;
  to: string;
  isHome?: boolean;
  isCurrent?: boolean;
}
const breadcrumbItems: BreadcrumbConfig[] = [{
  labelEn: "Home",
  labelZh: "首页",
  to: "/HomePage",
  isHome: true
}, {
  labelEn: "Wedge Wire Screens",
  labelZh: "约翰逊楔形滤网",
  to: "/WedgeWireScreenPage"
}, {
  labelEn: "Flat & Curved Panels",
  labelZh: "平板与弧形滤网",
  to: "/FlatCurvedPanelsPage",
  isCurrent: true
}];
export default function Breadcrumbs() {
  const [lang, setLang] = useState<"en" | "zh">("en");
  useEffect(() => {
    try {
      const savedLang = localStorage.getItem("mf_lang");
      if (savedLang === "zh" || savedLang === "en") {
        setLang(savedLang);
      }
    } catch {
      // Ignore localStorage errors
    }
    const handleCustomChange = (e: Event) => {
      const customEvent = e as CustomEvent<{
        lang?: "en" | "zh";
      }>;
      if (customEvent.detail?.lang) {
        setLang(customEvent.detail.lang);
      } else {
        const current = localStorage.getItem("mf_lang");
        if (current === "zh" || current === "en") {
          setLang(current);
        }
      }
    };
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "mf_lang" && (e.newValue === "zh" || e.newValue === "en")) {
        setLang(e.newValue);
      }
    };
    window.addEventListener("mf-language-change", handleCustomChange);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("mf-language-change", handleCustomChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  return <section id="breadcrumbnavigation" data-nav="light" className="w-full border-b border-border bg-background py-3.5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumb>
          <BreadcrumbList className="text-xs sm:text-sm text-muted-foreground">
            {breadcrumbItems.map((item, i) => {
            const label = lang === "zh" ? item.labelZh : item.labelEn;
            return <React.Fragment key={item.to}>
                  <BreadcrumbItem data-index={i}>
                    {item.isCurrent ? <BreadcrumbPage className="font-semibold text-foreground">
                        {label}
                      </BreadcrumbPage> : <BreadcrumbLink asChild>
                        <Link to={item.to} className="inline-flex items-center gap-1.5 transition-colors hover:text-foreground">
                          {item.isHome && <Home className="size-3.5" />}
                          <span>{label}</span>
                        </Link>
                      </BreadcrumbLink>}
                  </BreadcrumbItem>

                  {!item.isCurrent && <BreadcrumbSeparator className="text-muted-foreground/50">
                      <ChevronRight className="size-3.5" />
                    </BreadcrumbSeparator>}
                </React.Fragment>;
          })}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </section>;
}